module.exports = __webpack_public_path__ + "img/chatbot.8872bebe.png";